export default __webpack_public_path__ + "static/media/ccfolia_guidebook.8933d54d.png";